module.exports = import("https://connections-sdk.codat.io");;